import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App'
import router from './router'
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import firebase from 'firebase/app'
import 'firebase/firestore'
import IcFirebaseUploader from 'ic-firebase-uploader';
import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css';

import {Icon, default as L} from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/round.svg'),
  iconUrl: require('./assets/greenGps.svg'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

import 'leaflet/dist/leaflet.css';

import VueSingleSelect from "vue-single-select";
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import './css/leafletSearch.scss';    /* Input Search field */
import './css/leaflet.scss';     /* Map styling, zoom osv */

Vue.use(VueFlatPickr, VueSingleSelect, BootstrapVue, (require('vue-moment')));

Vue.component('ic-firebase-uploader', IcFirebaseUploader);

Vue.component('customer-color-badge', {
  props: ['colorname'],
  template: '' +
    '<div v-if="colorname === \'VI\'">' +
    '<b-badge class="custom-bg-vi">VI</b-badge></div>' +
    '<div v-else-if="colorname === \'BL\'"><b-badge class="custom-bg-bl">BL</b-badge></div>' +
    '<div v-else-if="colorname === \'BR\'"><b-badge class="custom-bg-br">BR</b-badge></div>' +
    '<div v-else-if="colorname === \'GR\'"><b-badge class="custom-bg-gr">GR</b-badge></div>' +
    '<div v-else-if="colorname === \'SV\'"><b-badge class="custom-bg-black">SV</b-badge></div>' +
    '<div v-else-if="colorname === \'GRÅ\'"><b-badge class="custom-bg-grey">GRÅ</b-badge></div>' +
    '<div v-else-if="colorname === \'OR\'"><b-badge class="custom-bg-or">OR</b-badge></div>' +
    '<div v-else-if="colorname === \'RÖ\'"><b-badge class="custom-bg-red">RÖ</b-badge></div>' +
    '<div v-else-if="colorname === \'VL\'"><b-badge class="custom-bg-vl">VL</b-badge></div>' +
    '<div v-else-if="colorname === \'RO\'"><b-badge class="custom-bg-pink">RO</b-badge></div>' +
    '<div v-else-if="colorname === \'TU\'"><b-badge class="custom-bg-tu">TU</b-badge></div>' +
    '<div v-else-if="colorname === \'GU\'"><b-badge class="custom-bg-gu">GU</b-badge></div>'
});

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

const config = {
  apiKey: "AIzaSyBZ7eLPJxnm_ACSB8oT-JjT2CltlDsBKE4",
  authDomain: "forsynsweden.firebaseapp.com",
  databaseURL: "https://forsynsweden.firebaseio.com",
  projectId: "forsynsweden",
  storageBucket: "forsynsweden.appspot.com",
  messagingSenderId: "303535351778",
  appId: "1:303535351778:web:12e3dad9183caa65"
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({ });
export const db = firebase.firestore();
export const fbapp = firebaseApp;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});







// WEBPACK FOOTER //
// ./src/main.js